import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    marginLeft: theme.spacing(-9),
  },
  title: {
    margin: theme.spacing(0.5, 0),
  },
  actionsContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
}))
